interface ObjectWithOriginFileObj {
  originFileObj: File;
}

export const isObjWithOriginFileObj = (file: object): file is ObjectWithOriginFileObj => {
  return 'originFileObj' in file && file.originFileObj instanceof File;
};
